import { PaymentService } from 'src/app/angularJS/services/payments/payments.service';
import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { ChargeAccountBaseComponent } from '../charge-account-base.component';

/**
 * A class that contains properties and methods relating to payments on a charge account
 */
export class ChargeAccountPaymentsController extends ChargeAccountBaseComponent {
  public static $inject = [
    'chargeAccount',
    'breadcrumbService',
    'customerService',
    'ACTToolbarService',
    'userService',
    '$state',
    '$translate',
    'paymentService'
  ];
  public payments: Array<InterACT.Interfaces.Payments.PaymentRequest> = [];
  public paymentStatuses = ['ALL', 'PROCESSING', 'AUTHORISED', 'SUCCESSFUL', 'FAILED', 'CANCELLED', 'VOIDED'];
  public paymentTypes = ['ALL', 'VERIFY', 'AUTH_AND_SETTLE', 'PRE_AUTH', 'CANCEL', 'FULFIL'];
  public paymentFilters = {
    fromDate: undefined,
    toDate: undefined,
    type: this.paymentTypes[0],
    status: this.paymentStatuses[0]
  };
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    currentPage: 0,
    perPageCount: 15,
    totalCount: 0
  };
  public customer: InterACT.Interfaces.Customers.Customer;

  private baseQuery = '';

  constructor(
    public chargeAccount: InterACT.Interfaces.ChargeAccounts.ChargeAccount,
    public breadcrumbService: BreadcrumbService,
    public customerService: CustomerService,
    public ACTToolbarService: ACTToolbarService,
    public userService: UserService,
    public $state: ng.ui.IStateService,
    public $translate: ng.translate.ITranslateService,
    private paymentService: PaymentService,
  ) {
    super(chargeAccount, breadcrumbService, customerService, ACTToolbarService, userService, $state, $translate);
    this.activate();
  }

  /**
   * A method is called whenever any of the paymentFilters on this controller have changed
   */
  public onFilterChanged = () => {
    return this.getPayments(this.paginatorData.currentPage, this.paginatorData.perPageCount);
  };

  /**
   * A method that getsa specified page of payments for the charge account
   * @param page the page number to retrieve
   * @param perPage the number of payments to retireve
   */
  public getPayments = (page: number, perPage: number) => {
    const query = this.constructQueryString();

    if (!perPage) {
      perPage = this.paginatorData.perPageCount;
    }

    return this.paymentService.getPaymentHistory(page, perPage, query).then((response) => {
      this.paginatorData.totalCount = response.meta.totalCount;
      this.payments = response.paymentRequests;
    });
  };

  /**
   * A method that constructs a qParam query string based on the selected payment filters held on this controller
   */
  private constructQueryString() {
    let query = this.baseQuery;

    if (this.paymentFilters.fromDate) {
      query += ' and date >= \'' + new Date(this.paymentFilters.fromDate).toISOString() + '\'';
    }

    if (this.paymentFilters.toDate) {
      query += ' and date <= \'' + new Date(this.paymentFilters.toDate).toISOString() + '\'';
    }

    if (this.paymentFilters.type && this.paymentFilters.type !== 'ALL') {
      query += ' and mode = \'' + this.paymentFilters.type + '\'';
    }

    if (this.paymentFilters.status && this.paymentFilters.status !== 'ALL') {
      query += ' and status = \'' + this.paymentFilters.status + '\'';
    }

    query += ' sortBy created desc';

    return query;
  }

  /**
   * A method that is called during controller instantiating to setup controller data
   */
  private activate() {
    this.baseQuery = 'paymentRequestItems.link = \'/charge-accounts/' + this.chargeAccount.id + '\'';

    this.setToolbarAndBreadcrumbs('charge-account-payments');
  }
}